import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from "@angular/core";
import {AbstractSelectControlComponent} from "./abstract-select-control.component";
import {FUIMoreControlComponent} from "@fedeltapointofsale/ui";
import {TranslateService} from "@ngx-translate/core";
import {ObjectUtils} from "../../utils/object-utils";

/**
 * "More" select filter control.
 */
@Component({
    selector: "wbo-more-select-control",
    templateUrl: "more-select-control.component.html"
})
export class MoreSelectControlComponent extends AbstractSelectControlComponent implements OnChanges {

    @ViewChild(FUIMoreControlComponent) selectControlComponent: FUIMoreControlComponent;

    @Output() onSelect: EventEmitter<any[]> = new EventEmitter();

    @Input() icon: string;
    @Input() iconSize: number = 16;

    private _selectControlValues: any[];

    constructor(changeDetector: ChangeDetectorRef, translateService: TranslateService) {
        super(changeDetector, translateService);
    }

    get selectControlValues(): any[] {
        return this._selectControlValues;
    }

    set selectControlValues(selectControlValues: any[]) {
        this._selectControlValues = selectControlValues;
        if (this._selectControlValues) {
            const itemValues: any[] = selectControlValues.map((item) => this.itemValue(item));
            if (!ObjectUtils.arraysEqual(super.value, itemValues)) {
                super.value = itemValues;
                this.onSelect.emit(selectControlValues);
            }
        }
    }

    click() {
        this.selectControlComponent.click();
    }

    focus() {
        this.selectControlComponent.focus();
    }

    /**
     * Compares the values as arrays
     * @param value1
     * @param value2
     * @returns {boolean}
     */
    override valueEqual(value1: any, value2: any): boolean {
        return !(value1 == undefined || value2 == undefined || value1.length !== value2.length || !value1.every((v, i) =>
            v === value2[i]));
    }

    evaluateValueChange(): void {
        if (this.value == undefined) {
            this._selectControlValues = null;
        } else {
            if (!Array.isArray(this.value)) {
                throw new Error("Value is not an array");
            }

            if (this._selectControlValues == undefined || !ObjectUtils.arraysEqual(this._selectControlValues.map((selectControlItem) => this.itemValue(selectControlItem)), this.value)) {
                if (this.data) {
                    this._selectControlValues = [];
                    this.value.forEach((valueItem) => {
                        const record: any = this.data.find(dataItem => this.itemValue(dataItem) === valueItem);
                        if (record) {
                            this._selectControlValues.push(record);
                        }
                    });
                }
            }
        }
    }

    itemValue(item: any) {
        return this.valueField ? item[this.valueField] : item;
    }

    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes["value"] || changes["data"]) {
            this.evaluateValueChange();
        }
    }

    override writeValue(obj: any): void {
        super.writeValue(obj);
        this.evaluateValueChange();
    }
}
